import React from 'react';
import { observer } from 'mobx-react';

import { CenteredCircularProgress } from 'components/Progress';

import ProfileNotificationsSettings from 'containers/ProfileNotificationsSettings';
import KnockPreferenceCenter from 'containers/KnockPreferenceCenter';

import { useStore } from 'utils/hooks/store';

const NotificationSettings: React.FunctionComponent = (): React.ReactElement => {
  const { dualInbox } = useStore();

  React.useEffect(() => {
    if (dualInbox.initialSync === undefined) {
      void dualInbox.loadInitialData();
    }
  }, []);

  if (dualInbox.initialSync !== true) {
    return <CenteredCircularProgress data-testid="notification-settings-loading" />;
  }

  return dualInbox.knockEnabled ? <KnockPreferenceCenter /> : <ProfileNotificationsSettings />;
};

export default observer(NotificationSettings);
